module.exports = __webpack_public_path__ + "img/purpose_mortgage.0556d927.svg";